import { render, staticRenderFns } from "./newOpen.vue?vue&type=template&id=28ed487f&scoped=true&"
import script from "./newOpen.vue?vue&type=script&lang=js&"
export * from "./newOpen.vue?vue&type=script&lang=js&"
import style0 from "./newOpen.vue?vue&type=style&index=0&id=28ed487f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed487f",
  null
  
)

export default component.exports